export default "__VITE_ASSET__BT6L3$Dx__"